import dark from './dark';
import light from './light';

const base = {
  dark,
  light,
};

export default { base };
